/**
 * CancelPaymentScreen — adaptateur primaire de la route `cancel-payment` (étape 4/5).
 *
 * Fil : les paramètres posés par l'étape 3 + la carte relue → le view-model, puis l'état du
 * prélèvement. Le bandeau du bas accuse la relecture de carte ; le refus du prélèvement, lui,
 * s'affiche dans la page (`paymentStatus` / `paymentNotice`).
 */
import React from "react"
import { useSelector } from "react-redux"

import { CancelPaymentPage, Snackbar } from "../../../../../../design-system"
import { type ApiDefaultPaymentMethod } from "../../../../adapters/parent/SubscriptionCancel/subscriptionCancelAdapter"
import { cancelPaymentViewModel } from "../../../../view-models/parent/SubscriptionCancel/cancelPaymentViewModel"
import { type CancelFlowScreenProps } from "./cancelFlowNavigation"
import { useCancelPaymentData } from "./useCancelPaymentData"
import { useCancelPaymentState } from "./useCancelPaymentState"

export function CancelPaymentScreen(props: CancelFlowScreenProps) {
    const routeParams = props.route?.params ?? {}
    const context = {
        motif: routeParams.motif,
        feesCents: routeParams.fees_cents ?? 0,
        creditCents: routeParams.credit_applied_cents ?? 0,
        balanceDueCents: routeParams.balance_due_cents ?? 0,
        dueCents: routeParams.amount_due_cents ?? null,
        endOfMonth: routeParams.end_of_month ?? null,
        milestoneCancellation: routeParams.milestone_cancellation,
        resumeDate: routeParams.resume_date ?? null,
        defaultPm: (routeParams.default_pm ?? null) as ApiDefaultPaymentMethod | null,
    }

    const data = useCancelPaymentData()
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const vm = useSelector((state: any) => cancelPaymentViewModel(state, context, data.refreshedPm))
    const state = useCancelPaymentState({
        routeParams,
        dueCents: vm.dueCents,
        endOfMonth: context.endOfMonth,
        billingPortalUrl: vm.billingPortalUrl,
    })

    return (
        <>
            <CancelPaymentPage
                amountLabel={vm.amountLabel}
                accessText={vm.accessText}
                summaryRows={vm.summaryRows}
                paymentMethod={vm.paymentMethod}
                paymentStatus={state.paymentStatus}
                paymentNotice={state.paymentNotice}
                onPay={state.actions.onPay}
                onUseAnotherCard={state.actions.onUseAnotherCard}
                onUpdateCard={state.actions.onUpdateCard}
                onReloadPaymentMethod={data.reload}
                reloading={data.reloading}
                confirmVisible={state.confirmVisible}
                confirmMessage={vm.confirmMessage}
                onConfirm={state.actions.onConfirm}
                onCancelConfirm={state.actions.onCancelConfirm}
                onBack={state.actions.onBack}
                onClose={state.actions.onClose}
            />
            <Snackbar
                visible={data.feedback != null}
                message={data.feedback ?? ""}
                tone="danger"
                onDismiss={data.dismissFeedback}
            />
        </>
    )
}

export default CancelPaymentScreen
